<template>
  <div
    class="radio__input flex items-center"
    :class="[color, size]"
  >
    <input
      :id="id"
      type="radio"
      :name="name"
      class="hidden"
      :checked="shouldBeChecked"
      :value="value"
      :disabled="isDisable"
      @change="updateInput"
    >
    <label
      :for="id"
      class="flex items-center cursor-pointer"
    >
      <span />
      <slot>
        {{ label }}
      </slot>
    </label>
  </div>
</template>

<script>
export default {
  name: 'InputRadio',
  model: {
    prop: 'modelValue',
    event: 'change'
  },
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    modelValue: {
      type: [String, Number],
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    id: {
      type: [String, Number],
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: 'primary'
    },
    size: {
      type: String,
      default: 'md'
    },
    isDisable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    shouldBeChecked () {
      return this.modelValue === this.value
    }
  },
  methods: {
    updateInput () {
      this.$emit('change', this.value)
    }
  }
}
</script>

<style lang="scss">
//primary
.radio__input {
  &.primary {
    input[type="radio"] + label {
      @apply text-gray-main;
    }
    input[type="radio"] + label span {
      @apply border-gray-medium;
    }
    input[type="radio"]:checked + label span:before {
      @apply bg-blue-primary border-blue-primary;
    }
  }
  &.danger {
    input[type="radio"] + label {
      @apply text-gray-main;
    }
    input[type="radio"] + label span {
      @apply border-red-500;
    }
  }
  &.secondary {
    input[type="radio"] + label {
      @apply text-white;
    }
    input[type="radio"] + label span {
      @apply border-yellow-primary bg-white;
    }
    input[type="radio"]:checked + label span {
      @apply border-white;
    }
    input[type="radio"]:checked + label span:before {
      @apply bg-yellow-primary;
    }
  }
  &.white {
    input[type="radio"] + label {
      @apply text-gray-main;
    }
    input[type="radio"] + label span {
      @apply border-gray-medium bg-white;
    }
    input[type="radio"]:checked + label span {
      @apply border-gray-medium;
    }
    input[type="radio"]:checked + label span:before {
      @apply bg-blue-primary;
    }
  }
  &.green {
    input[type="radio"] + label {
      color: theme("colors.gray.medium");
    }
    input[type="radio"] + label span {
      @apply border-green-500;
    }
    input[type="radio"]:checked + label span:before {
      @apply bg-green-500 border-green-500;
    }
  }
  &.red {
    input[type="radio"] + label {
      color: theme("colors.gray.medium");
    }
    input[type="radio"] + label span {
      @apply border-red-500;
    }
    input[type="radio"]:checked + label span:before {
      @apply bg-red-500 border-red-500;
    }
  }
  &.blue {
    input[type="radio"] + label {
      color: theme("colors.gray.medium");
    }
    input[type="radio"] + label span {
      @apply border-blue-primary;
    }
    input[type="radio"]:checked + label span:before {
      @apply bg-blue-primary border-blue-primary;
    }
  }
  &.md {
    input[type="radio"] + label {
      @apply text-base  font-normal;
    }
  }
  &.sm,
  &.small {
    input[type="radio"] + label {
      @apply text-xs md:text-sm  font-normal;
    }
  }
  input[type="radio"] + label span {
    transition: background 0.2s, transform 0.2s;
  }

  input[type="radio"] + label span:hover,
  input[type="radio"] + label:hover span {
    transform: scale(1.2);
  }
  input[type="radio"] + label span {
    @apply relative w-5 h-5 inline-block ml-3 rounded-full border-2;
    &:before {
      @apply rounded-full absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transform   w-[10px] h-[10px];
      content: "";
    }
  }
}
</style>
